/** 旧 CPQ 路由兼容边界：仅保存对象/版本地址，不存报价、客户或分享 token。 */
import type { Quote } from '../pages/cpq-v2/state/types';
import { isFormalNewQuoteId } from './quoteLegacyProjection';

/**
 * Preserve unknown version ids because they can identify a historical version.
 * Correct only versions already proven, by the open local tabs, to belong to
 * a different quote. Temporary new tabs never have a server version.
 */
export function bindKnownQuoteVersion(
  quoteId: string,
  versionId: string | undefined,
  quotes: Record<string, Quote>,
): string | undefined {
  if (isFormalNewQuoteId(quoteId)) return undefined;
  if (!versionId) return undefined;
  const belongsToAnotherQuote = Object.entries(quotes).some(
    ([otherId, quote]) =>
      otherId !== quoteId && quote.formalVersionId === versionId,
  );
  return belongsToAnotherQuote ? quotes[quoteId]?.formalVersionId : versionId;
}

export function readQuoteWorkspaceRoute(search: string) {
  const query = new URLSearchParams(search);
  const quoteIds = query.getAll('quoteId');
  const versionIds = query.getAll('quoteVersionId');
  if (!quoteIds.length && !versionIds.length) return null;
  if (
    quoteIds.length !== 1 ||
    !/^[1-9][0-9]{0,18}$/.test(quoteIds[0]) ||
    versionIds.length > 1
  )
    throw new Error('报价工作台地址参数无效');
  if (versionIds.length && !/^[1-9][0-9]{0,18}$/.test(versionIds[0]))
    throw new Error('报价工作台版本参数无效');
  return { quoteId: quoteIds[0], quoteVersionId: versionIds[0] };
}

export function quoteWorkspaceSearch(
  search: string,
  quoteId?: string,
  quoteVersionId?: string,
) {
  const query = new URLSearchParams(search);
  query.delete('quoteId');
  query.delete('quoteVersionId');
  if (quoteId) query.set('quoteId', quoteId);
  if (quoteId && quoteVersionId !== undefined)
    query.set('quoteVersionId', quoteVersionId);
  return query.size ? `?${query}` : '';
}
